import './combi-tips.scss';

import Swiper from 'swiper';
import { A11y, Navigation, Pagination, Keyboard } from 'swiper/modules';
import 'swiper/scss/a11y';
import 'swiper/scss/keyboard';

require('../../assets/images/flares.svg');
require('../../assets/images/kombi-tips-stoerer.svg');

class CombiTip {
    constructor ($element) {
        // slider
        this.$combitips = $element;
        this.$slider = this.$combitips.querySelectorAll('[data-combi-tip-slider="slider"]');
        this.$prevButton = this.$combitips.querySelector('[data-slider-prev]');
        this.$nextButton = this.$combitips.querySelector('[data-slider-next]');

        // tabs
        this.$tabs = document.querySelector('[data-combi-tip="tabs"]');
        this.$tabsTrigger = this.$tabs.querySelectorAll('[data-combi-tip="trigger"]');
        this.$tabsContents = this.$tabs.querySelectorAll('[data-combi-tip="content"]');
        this.$form = this.$combitips.closest('[data-lot-selection="form"]');

        this.slider = [];
        this.sliderActive = false;
        this.centered = true;
    }

    initialize () {
        this.checkSize();

        if (this.$tabs) {
            this.setTabEvents();
        }
    }

    // slider functions
    checkSize () {
        if (window.innerWidth < 1280) {
            if (!this.sliderActive) {
                this.initSlider();
            }
        }

        window.resizeHandler.customFunctions.push(() => {
            if (window.innerWidth < 1280) {
                if (!this.sliderActive) {
                    this.initSlider();
                }
            } else {
                this.destroySlider();
            }
        });
    }

    initSlider () {
        for (let i = 0; i < this.$slider.length; i++) {
            this.slider[i] = new Swiper(this.$slider[i], {
                modules: [A11y, Navigation, Pagination, Keyboard],
                direction: 'horizontal',
                centeredSlides: true,
                slidesPerView: 1.2,
                spaceBetween: 15,
                slideToClickedSlide: false,
                speed: 500,
                initialSlide: 1,
                breakpointsInverse: true,
                pagination: {
                    el: '.combi-tip-slider__swiper-pagination',
                    clickable: false
                },
                a11y: {
                    prevSlideMessage: window.translations.prev_slide_message,
                    nextSlideMessage: window.translations.next_slide_message,
                    paginationBulletMessage: `${window.translations.pagination_bullet_message} {{index}}`,
                    firstSlideMessage: window.translations.first_slide_message,
                    lastSlideMessage: window.translations.last_slide_message,
                    slideLabelMessage: `${window.translations.slide_label} {{index}} ${window.translations.slide_label_from} {{slidesLength}}`
                },
                navigation: {
                    nextEl: this.$nextButton,
                    prevEl: this.$prevButton
                },
                keyboard: true,
                breakpoints: {
                    640: {
                        slidesPerView: 1.3,
                        spaceBetween: 20
                    },
                    767: {
                        slidesPerView: 1.9,
                        spaceBetween: 35
                    }
                }
            });
        }

        this.sliderActive = true;
    }

    destroySlider () {
        for (let i = 0; i < this.slider.length; i++) {
            if (this.slider[i] !== null) {
                this.slider[i].destroy(true, true);
                this.slider[i] = null;
            }
        }

        this.sliderActive = false;
    }

    // tab functions
    displayCurrentTab (index) {
        this.$tabsContents[index].classList.add('is-active');
        this.$tabsTrigger[index].classList.add('is-active');

        if (index === 0) {
            this.$tabsContents[1].classList.remove('is-active');
            this.$tabsTrigger[1].classList.remove('is-active');
        } else {
            this.$tabsContents[0].classList.remove('is-active');
            this.$tabsTrigger[0].classList.remove('is-active');
        }
    }

    setTabEvents () {
        for (let index = 0; index < this.$tabsTrigger.length; index++) {
            this.$tabsTrigger[index].addEventListener('click', event => {
                this.displayCurrentTab(index);
            });
        }
    }
}

export { CombiTip };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    const $combiTips = $context.querySelector('[data-combi-tips="root"]');

    if ($combiTips) {
        const $combi = new CombiTip($combiTips);
        $combi.initialize();
    }
});
